<script lang="ts">import "svelte/transition";
import "svelte/easing";
import "./images/img_avatar.png";
import { onMount } from 'svelte';
export let url = "";
let width = Math.round(Math.random() * 10000) % 10 + 45;
let step = 1;
onMount(() => {
    const timerId = setInterval(() => {
        width += step;
        if (width > 54) {
            step = -1;
        }
        else if (width < 46) {
            step = 1;
        }
    }, 50);
    return () => {
        clearInterval(timerId);
    };
});
</script>

<div class="avatar" style={`
  width: ${width}px;
  height: ${width}px;
`}>
  <img src={url} alt="avatar" />
</div>

<style type="text/scss">*, *::after, *::before {
  box-sizing: border-box;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 10px 1px rgba(0,0,0,0.53333);
}

.avatar img {
  width: 100%;
  height: 100%;
  display: block;
}</style>
